var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import jQuery from 'jquery';
import { createRoot } from 'react-dom/client';
import ImportAxios from '@themes/common/axios';
const ListUsersInCompany = ({ title, userId, companyId }) => {
    const [users, setUsers] = useState([]);
    useEffect(() => {
        const fetchUsers = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const axios = yield ImportAxios();
            const result = yield axios.get(`${process.env.HOST}/api/customers`, {
                params: {
                    user_id: userId,
                    company_id: companyId,
                },
            });
            if ((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.rows) {
                setUsers(result.data.rows);
            }
        });
        fetchUsers();
    }, [userId, companyId]);
    return users.length > 0 ? (_jsxs(_Fragment, { children: [_jsx("h2", Object.assign({ className: 'account-page-subtitle' }, { children: title })), _jsx("ul", Object.assign({ className: 'company-user--list' }, { children: users.map(({ id, email, first_name, last_name }) => (_jsxs("li", Object.assign({ className: 'company-user--list-item' }, { children: [_jsxs("strong", { children: [first_name, " ", last_name] }), _jsx("br", {}), _jsx("a", Object.assign({ href: `mailto:${email}`, title: `Email ${first_name} ${last_name}` }, { children: email }))] }), id))) }))] })) : (_jsx(_Fragment, {}));
};
export default function renderLists(element) {
    const data = jQuery(element).data();
    const rootDom = createRoot(element[0]);
    rootDom.render(_jsx(ListUsersInCompany, Object.assign({}, data)));
}
